import { NgrxValueConverter } from 'ngrx-forms';
import * as moment from 'moment';

export const MOMENT_DATE_VALUE_CONVERTER: NgrxValueConverter<moment.Moment | null, string | null> =
  {
    convertViewToStateValue(datetime: moment.Moment | null) {
      if (moment.isMoment(datetime) && datetime.isValid()) {
        return datetime.format();
      }

      return null;
    },
    convertStateToViewValue(datetime: string | null) {
      return datetime ? moment.parseZone(datetime) : null;
    }
  };
